import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchLichSuBank } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";
import { DongBoLichSuDesktopBtn } from "./DongBoLichSuDesktopBtn";

export const TableDanhSach = ({ dataDanhSach, onSearch }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchLichSuBank);
  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    dispatch(
      updateDataSearchLichSuBank({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    onSearch();
  };
  const handlePageSizeChange = (pageSize) => {
    dataSearch.iPageSize = pageSize;
    dataSearch.iPageIndex = 1;
    dispatch(
      updateDataSearchLichSuBank({
        ...dataSearch,
        iPageSize: pageSize,
        iPageIndex: 1,
      })
    );
    onSearch();
  };
  return (
    <>
    <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div style={{paddingLeft :"20px", paddingTop :"20px"}}>
          {" "}
          <DongBoLichSuDesktopBtn data={""} onSearch={onSearch} />
        </div>
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
        <div className="table-mobile table-mobile-hover">
          <div className="custom-table-wrapper">
            <div className="table-headers">
              <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                <p className="text-center">
                  STT
                  <br /> <span className="color-do-bold">[ {dataDanhSach.iTotal} ]</span>
                </p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-19-sm">
                <p className="text-center">Mã tham chiếu</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                <p className="tab-header  text-center">Số tài khoản</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                <p className="tab-header  text-center">Ngày giao dịch</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-20-sm">
                <p className="tab-header  text-center">Số tiền</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-11-4-sm">
                <p className="tab-header  text-center">Nội dung</p>
              </div>
            </div>

            <div className="custom-table-body" >
              {typeof dataDanhSach.List != "undefined" &&
                dataDanhSach.List.length > 0 && (
                  <ContentTable
                    dataDanhSach={dataDanhSach}
                    onSearch={onSearch}
                  />
                )}
              {typeof dataDanhSach.List === "undefined" ||
                (dataDanhSach.List.length === 0 && <div>Không có dữ liệu</div>)}
            </div>
          </div>
        </div>
      </div>
          </div>
        </div>
      
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.iPageIndex}
            pageSize={dataSearch.iPageSize}
            totalCount={dataDanhSach.iTotal}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
